var _metadata, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPirateRightArmTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 100 150",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, "Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#26180a",
    d: "M37 67h6M37 68h6M37 69h6M33 70h7M33 71h7M33 72h7M33 73h4M33 74h4M33 75h4M33 76h4M30 77h3M30 78h3M30 79h3M30 80h3M43 80h4M30 81h3M43 81h4M30 82h3M43 82h4M30 83h3M40 83h3M30 84h3M40 84h3M30 85h3M40 85h3M30 86h3M40 86h3M33 87h4M40 87h3M33 88h4M40 88h3M33 89h4M40 89h3M40 90h3M40 91h3M40 92h3M37 93h3M37 94h3M37 95h3M37 96h3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#513215",
    d: "M40 70h7M40 71h7M40 72h7M37 73h3M37 74h3M37 75h3M37 76h3M33 77h4M33 78h4M33 79h4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3a240f",
    d: "M40 73h7M40 74h7M40 75h7M40 76h7M37 77h10M37 78h10M37 79h10M33 80h10M33 81h10M33 82h10M33 83h7M33 84h7M33 85h7M33 86h7M37 87h3M37 88h3M37 89h3M33 90h7M33 91h7M33 92h7M33 93h4M33 94h4M33 95h4M33 96h4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#191006",
    d: "M30 87h3M30 88h3M30 89h3M30 90h3M30 91h3M30 92h3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPirateRightArmTop);
export default __webpack_public_path__ + "static/media/pirate-RightArmTop.539d841a902d533b8db09dcfecd50901.svg";
export { ForwardRef as ReactComponent };